import Vue from "vue"
import comp from "@/components/general/modal.vue"

Vue.component('modal', comp);

var modals = {};

var vm = new Vue({
	data() {
		return {
			modals: modals
		}
	}
})

var modal = {
	show(name) {
		vm.modals[name] = true;
	},
	close(name) {
		vm.modals[name] = false;
	},

	register(name, value) {
		if (value === undefined) {
			value = false
		}
		Vue.set(vm.modals, name, false)
	},

	check(name) {
		return vm.modals[name];
	},
	modals: vm.modals
}


export default modal;


// WEBPACK FOOTER //
// ./src/utils/modal.js